import { until } from '@js/utils/until'

/**
 * Build video embed script.
 * @param {HTMLElement} parent
 * @param {string} options
 */
const buildVideoEmbedScript = (parent, options) => {
	const script = document.createElement('script')
	const embedHTML = `kWidget.embed({${options}});`
	script.innerHTML = embedHTML
	parent.appendChild(script)
}

/**
 * Clean up video embed code.
 * @param {HTMLTemplateElement} template
 * @returns object
 */
const updateVideoCode = (template) => {
	// Get template content.
	const code = template.content.cloneNode(true)

	// Setup variables.
	let kalturaScript, kalturaID, kalturaOptions

	// Loop through template content.
	Array.from(code?.children).forEach(child => {
		// Find kaltura ID.
		if (child.tagName === 'DIV') {
			kalturaID = child.id
			return
		}

		if (child.tagName === 'SCRIPT') {
			// Find kaltura script.
			if (child.src.includes('cdnapisec.kaltura.com')) {
				kalturaScript = child
				return
			}

			// Find kaltura options.
			if (child.textContent.includes('kWidget.thumbEmbed')) {
				// regex to find get all text between "({" and "})"
				let formattedText = child.textContent
					.replace(/(?:.*kWidget\.thumbEmbed\({)/, '')
					.replace(/(\}\);)/, '')
				formattedText = JSON.stringify(formattedText)
				kalturaOptions = JSON.parse(formattedText)
				return
			}
		}
	})

	return { kalturaID, kalturaOptions, kalturaScript }
}

/**
 * Clean up captions embed code.
 * @param {HTMLTemplateElement} template
 * @returns object
 *
 */
const updateCaptionsCode = (template) => {
	let iframe
	const code = template.content.cloneNode(true)
	iframe = code.children[0]
	iframe.style.height = '100%'
	iframe.style.width = '100%'
	return { iframe }
}

/**
 * Run Setup Video Embed functions.
 * @returns
 */
const setupVideoEmbed = () => {
	const embeds = document.querySelectorAll('[data-video-embed]')
	// If no embeds, return.
	if (!embeds) { return }

	// Loop through embeds.
	embeds.forEach(embed => {
		// Setup variables.
		const videoCode = embed.querySelector('[data-video-embed-player]')
		const captionsCode = embed.querySelector('[data-video-embed-captions]')
		const trigger = embed.querySelector('[data-video-embed-trigger]')

		// If no video, captions, or trigger, return.
		if (!videoCode || !captionsCode || !trigger) { return }

		// Run cleanup functions.
		const { kalturaID, kalturaOptions, kalturaScript } = updateVideoCode(videoCode)
		const { iframe } = updateCaptionsCode(captionsCode)

		// Clean up templates.
		const videoParent = videoCode.parentNode
		const captionsParent = captionsCode.parentNode
		videoParent.removeChild(videoCode)

		// load Kaltura script to HEAD
		document.head.appendChild(kalturaScript)

		// On click of trigger, update video embed code
		trigger.addEventListener('click', () => {
			// Build Video Container
			const container = document.createElement('div')
			container.id = kalturaID
			container.classList.add('kaltura-player')
			videoParent.appendChild(container)

			// Load Video
			until('kWidget' in window).then(buildVideoEmbedScript(videoParent, kalturaOptions))

			// Load Captions
			captionsParent.replaceChildren(iframe, captionsCode)

			// Set data attribute to loaded
			embed.setAttribute('data-video-embed', 'loaded')

			return
		}, { once: true })
	})
}

export { setupVideoEmbed }
